'use strict';

import { Component, EventEmitter, Inject, Output, Input } from 'ng-metadata/core';
import { SearchFieldsService } from '../search.fields.service';
import { SearchBarService } from './searchBar.service';
import { VoiceSearchToastService } from './voiceSearchToast.service';
import { AutoComplete } from '../autocomplete.service';
import { IAlertMsg } from '../../infra/widgets/alerts/alertMsg.interface';
import { AlertFactory, ALERT_MSG_TYPE } from '../../infra/widgets/alerts/alertFactory.service';
import { preventStateReload } from '../../infra/annotations';
import { PrimolyticsService, beacon } from '../../analytics/primolytics.service';
import { AddQueryToSavedSearchesService } from '../../search/savedQueries/addQueryToSavedSearches/addQueryToSavedSearches.service';
import { ConfigurationUtil } from '../../nddUtils/configurationUtil.service';
import { SearchHistoryService } from '../../favorites/searchHistory/searchHistory.service';
import { SavedQueriesService } from '../../favorites/savedQueries/savedQueries.service';

import {getSearchScopesMap, updateSearchScopesMap, getVid, getFindInDbPerTabs,isAutoSearchOnTabChange, getInstitutionCode,getSearchDBOption, getChosenKeepMeSignInConf, getPersonEntityAutocompleteUrl, getEnablePersonEntityAutocomplete} from '../../appConfig/appConfigForward';
import { getScopeList } from '../../appConfig/appConfigForward';
import { SmoothScrollUtil } from "../../nddUtils/smoothScrollUtil.service";
import { StringUtils } from '../../nddUtils/stringUtils.service';
import { MediaQueries } from '../../infra/mediaQueries.service';

import { STATE_NAMES } from '../../primoExplore/primoExploreStates.module';
import { SearchUtil } from '../../nddUtils/searchUtil.service';

import { TabsAndScopesSelectorService } from './tabsAndScopesSelector/tabsAndScopesSelector.service';
import { JwtUtilService } from '../../security/jwtUtil.service';
import { getAttributesMap } from '../../appConfig/appConfigForward';
import { SearchService } from "../search.service";
import { StorageUtil } from "../../infra/storageUtil.service";
import { getBackendSystem } from "../../appConfig/appConfigForward"
import { isShowReasearcherAssistantByIcon } from "../../appConfig/appConfigForward"
import { PreFiltersService } from "../preFilters/preFilters.service";
import { ResourceTypeFilterBarService} from "../resourceTypeFilterBar/resourceTypeFilterBar.service";
import { MappingTablesCache } from "../../mappingTablesCache/mappingTablesCache.service";
import { TemplateUtil } from '../../nddUtils/templateUtil.service';
import { AdvancedSearchService } from './advancedSearch.service';
import {TimeoutToastService} from "../../security/timeoutToast/timeoutToast.service";
import { DEFAULT_SEARCH_OPERATOR } from '../searchBar/searchBar.service';
import { ResearchAssistantService } from '../../researchAssistant/researchAssistant.service';
import { getUrlPathname } from '../../nddUtils/urlUtil';

let get= require('lodash/get');
let isEmpty = require('lodash/isEmpty');
let annyang = require('annyang');

interface Suggestion {
    tab?: string;
    display?: string;
}

const MAX_AUTOCOMPLETE_ROWS = 8;
const NUMBER_OF_RECENT_SEARCHES = 1;
const MAX_PERSONS_AUTOCOMPLETE_ROWS = 2;

const find = require('lodash/find');

@Component({
    'selector': 'prm-search-bar',
    templateUrl: 'components/search/searchBar/search-bar.html',
})


export class PrmSearchBar {
    @Input() private hasSearchResults: string;
    private query: string;
    private _scopeField: Object;
    private _selectedTab: string;
    private _switchedFromSimpleToAdvanced: boolean;
    private scopesDialerConfiguration: ScopesDialerConfiguration;
    @Output() private searchEvent = new EventEmitter();
    private _signInAlert: IAlertMsg;
    private showTabsAndScopes;
    private tabs: Suggestion[];
    private searchScopesMap = getSearchScopesMap();
    private selectedItem: Suggestion;
    private typedQuery: string;
    private _placeHolderText: string;
    private _clearButtonText: string;
    private _searchFieldText: string;
    private DEFAULT_TARGET_OPERATOR = 'any'
    private PERSON_AUTOCOMPLETE_API_URL = getPersonEntityAutocompleteUrl();
    private DEFAULT_SEARCH_OPERATOR = DEFAULT_SEARCH_OPERATOR;
    private searchHistoryItems: any[];
    private autocompleteLength: number;
    private _isShowFindDBButton: boolean;
    private _isShowRecentSearches: boolean = true;
    private focusOnSearchInput: boolean = true;
    private _advancedSearchCollapsed: boolean = false;
    private USE_SEARCH_HISTORY = 'useSearchHistory';
    private _isUseSearchHistory: boolean=true;


    private vid = getVid();
    private timeoutPromise;
    private RESEARCH_ASSISTANT_STATE = STATE_NAMES.RESEARCH_ASSISTANT;

    public pFilters = {};
    private readonly MIN_AUTOCOMPLETE_TERM_LENGTH = 3;

    constructor(@Inject('$stateParams') private $stateParams: angular.ui.IStateParamsService,
        @Inject('$location') private $location: ng.ILocationService,
        @Inject('scopesIcons') private scopesIcons: Object[],
        @Inject('$scope') private $scope: ng.IScope,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        @Inject('$http') private $http: angular.IHttpService,
        @Inject('searchBoxIcons') private searchBoxIcons: Object[],
        @Inject('$mdDialog') private $mdDialog,
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$mdToast') private $mdToast: ng.material.IToastService,
        private mediaQueries: MediaQueries,
        private searchFieldsService: SearchFieldsService,
        private autocompleteService: AutoComplete,
        private searchBarService: SearchBarService,
        private voiceSearchToastService: VoiceSearchToastService,
        private alertService: AlertFactory,
        private addQueryToSavedSearchesService: AddQueryToSavedSearchesService,
        private smoothScrollUtil: SmoothScrollUtil,
        private stringUtil: StringUtils,
        private searchUtil: SearchUtil,
        private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
        private jwtUtilService: JwtUtilService,
        private configurationUtil: ConfigurationUtil,
        private searchService: SearchService,
        private storageUtil: StorageUtil,
        private mtCache: MappingTablesCache,
        private searchHistoryService: SearchHistoryService,
        private savedQueriesService: SavedQueriesService,
        private preFiltersService: PreFiltersService,
        private resourceTypeFilterBarService :ResourceTypeFilterBarService,
        private primolyticsService: PrimolyticsService,
        private templateUtil: TemplateUtil,
        private advancedSearchService: AdvancedSearchService,
        private timeoutToastService: TimeoutToastService,
        private researchAssistantService: ResearchAssistantService) {

        this.tabs = [];
        Object.keys(this.searchScopesMap).slice(0, MAX_AUTOCOMPLETE_ROWS).forEach((e, i) => {
            let code = 'tabbedmenu.' + e + '.label';
            let tab = { tab: e, displayName: '' };
            this.$translate(code).then((translation) => {
                tab.displayName = translation
            });
            this.tabs.push(tab);

        });

        $translate('nui.search.placeholder').then((translation) => {
            this._placeHolderText = translation
        });
        this.initStateFromUrl($stateParams);
        this.$scope.$on('$stateChangeSuccess', (event, toState) => {
            if (toState.name === STATE_NAMES.SEARCH) {
                this.initStateFromUrl($stateParams);
            }
        });

        $translate('nui.searchField.clear').then((translation) => {
            this._clearButtonText = translation
        });

        $translate('nui.aria.search.searchField').then((translation) => {
            this._searchFieldText = translation
        });

        this.scopesDialerConfiguration = {
            display: false,
            isOpen: false,
            direction: 'down',
            iconsArray: scopesIcons,
            autoHideToolTip: false,
            toolTipDelay: 100,
            toolTipDirection: 'right',
            tooTipDefaultOpen: false
        };
        this._signInAlert = this.alertService.create(ALERT_MSG_TYPE.SIGNIN);
        this._signInAlert.show('nui.search.tnsearch.error.authorization', true);
        if (getBackendSystem() !== 'suprima') {
            this.updateShowFindDBButton();
        }

        this.setSearchHistoryItems();
        this.focusOnSearchInput = (this.mtCache.getTable(this.mtCache.tables.VIEW_PROPERTIES).filter((row) => row.source1 === this.vid && row.source2 === 'focus_on_search_input' && row.target === 'true').length === 1);
        let recentSearchesDisabled = this.mtCache.findByProperties('Recent Searches Configuration', { target: getInstitutionCode(), source1: 'N' }).length > 0; // OTB enabled
        if (recentSearchesDisabled) {
            this._isShowRecentSearches = false;
        }

    }
    public onChangeTabEvent(event) {
        if (isAutoSearchOnTabChange()) { // tabsRemote is true we need to invoke a search on tab change
            setTimeout(() => {
                this.search(event)
            }, 0); //we need a timeout so that _selectedTab is updated before search is invoked
        }
    }

    get mainSearchField() {
        return this.searchFieldsService.mainSearch;
    }

    set mainSearchField(mainSearchField) {
        this.searchFieldsService.mainSearch = mainSearchField;
    }

    get scopeField() {
        return this._scopeField;
    }

    set scopeField(scopeField) {
        this._scopeField = scopeField;
    }

    get switchedFromSimpleToAdvanced() {
        return this._switchedFromSimpleToAdvanced;
    }

    set switchedFromSimpleToAdvanced(switchedFromSimpleToAdvanced) {
        this._switchedFromSimpleToAdvanced = switchedFromSimpleToAdvanced;
    }


    private updateAdvancedSearchParams(event) {
        this.advancedSearchCollapsed = event.advancedSearchCollapsed;
    }

    get advancedSearchCollapsed() {
        return this._advancedSearchCollapsed;
    }

    set advancedSearchCollapsed(advancedSearchCollapsed) {
        this._advancedSearchCollapsed = advancedSearchCollapsed;
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(tab) {
        this._selectedTab = tab;
    }

    get autoCompleteItems() {
        return this.searchBarService.autoCompleteItems;
    }

    set autoCompleteItems(items) {
        this.searchBarService.autoCompleteItems = items;
    }

    get showSignIn() {
        return this.searchBarService.showSignIn;
    }

    get placeHolderText() {
        return this._placeHolderText;
    }

    get clearButtonText() {
        return this._clearButtonText;
    }

    get searchFieldText() {
        return this._searchFieldText;
    }

    get signInAlert(): IAlertMsg {
        return this._signInAlert;
    }

    get advancedSearch() {
        return this.searchFieldsService.advancedSearch;
    }

    get isPreFilterEnable() {
        return !this.advancedSearch && this.preFiltersService.isPreFilterEnable(this.selectedTab);
    }

    get isResourceTypeFilterBarEnable(){
        return !this.advancedSearch && this.resourceTypeFilterBarService.isResourceTypeFilterBarEnabled();
    }

    get isUseSearchHistory() {
        return this._isUseSearchHistory;
    }

    set isUseSearchHistory(value) {
        this._isUseSearchHistory = value;
    }

    get acTriggered(): boolean {
        return this.searchBarService.acTriggered;
    }

    set acTriggered(value: boolean) {
        this.searchBarService.acTriggered = value;
    }

    public search(event) {
        this.onSubmit();
    }

    public getSubmitAriaLabelCode() {
        if (this.isPreFilterEnable) {
            return 'nui.aria.continuePreFilters';
        }
        return 'nui.aria.submitSearch';
    }

    showTabsAndScopesVal() {
        if (!this.showTabsAndScopes) {
            if (this.tabs.length === 1) {
                return true;
            }
            return undefined;

        }
        return this.showTabsAndScopes;

    }

    private ngOnInit() {
        if (this.$state.current.name === STATE_NAMES.FULL_DISPLAY && this.$stateParams['mode'] === "advanced" && this.$stateParams['searchType'] === "barcode"){
            this.searchFieldsService.advancedSearch = true; //to open the advanced search section (note: not related to expanding/collapsing the section)
        }
        this.autocompleteLength = this.calculateAtocompleteLength();
        if (this.searchFieldsService.advancedSearch) {
            //Reaching  advanced search from an 'external source' will consider the user choice in SessionStorage
            this.advancedSearchCollapsed = !(this.advancedSearchService.getSessionAdvancedSearchMode()=='expanded') && this.$stateParams['query'];
        }

        if (this.$state.current.name === STATE_NAMES.PERSON_ENTITY_PAGE){ //clearing the search bar query when loading the person entity page
            this.mainSearchField = '';
        }


        // Set autofocus to input search bar
        this.$timeout(() => {
            if (this.mediaQueries.gtmd && this.focusOnSearchInput) {
                let elem = document.querySelector('#searchBar');
                if (elem) {
                    elem.focus();
                }
            }
        }, 0);
    }

    private calculateAtocompleteLength() {
        if (this.mediaQueries.xs) {
            return 51;
        }
        if (this.mediaQueries.sm) {
            return 58;
        }
        if (this.mediaQueries.md) {
            return 77;
        }
        if (this.mediaQueries.lgPlus) {
            return 105;
        }
        if (this.mediaQueries.lg) {
            return 94;
        }

        // then it needs to be this.mediaQueries.xl
        return 114;
    }

    private initStateFromUrl($stateParams) {

        let curScope = this.searchUtil.getValidScope($stateParams.search_scope);
        let curTab = $stateParams.tab;

        if (!$stateParams.query && !curTab && !curScope) {
            this.selectedTab = this.tabs[0].tab;
            this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            return;
        }

        if (curTab) {
            this.selectedTab = curTab;
            if (curScope) {
                this.scopeField = curScope;
            } else {
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
        } else {
            if (curScope) {
                this.scopeField = curScope;
                this.selectedTab = find(getScopeList(), (scope) => scope['scope-id'] === this.scopeField).tab;
            } else {
                this.selectedTab = this.tabs[0].tab;
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
        }
        this.searchFieldsService.tab = this.selectedTab;
        if (this.tabsAndScopesSelectorService.isRecentScopesEnabled) {
            this.tabsAndScopesSelectorService.addRecentScopeToSession(this.selectedTab, this.scopeField);
        }
        this.showTabsAndScopes = true;
        return;
    }

    @preventStateReload
    private switchAdvancedSearch() {
        this.searchFieldsService.advancedSearch = !this.searchFieldsService.advancedSearch;
        this.switchedFromSimpleToAdvanced = this.searchFieldsService.advancedSearch;
        //switching from simple to advance - advanced search is always expanded
        this.advancedSearchCollapsed = this.searchBarService.isAdvancedCollapsed(this.$stateParams['query'], this.switchedFromSimpleToAdvanced);
        if (!this.searchFieldsService.advancedSearch) {
            this.smoothScrollUtil.focusOn('searchBar');
        }
        this.$location.search('mode', this.searchFieldsService.advancedSearch ? 'advanced' : 'simple');
        if (this.$location.search().searchType === "barcode"){
            let searchParams= this.$location.search();
            searchParams.searchType=undefined;
            searchParams.barcode=undefined;
            this.$location.search(searchParams).replace();
        }

        this.$timeout(() => {
            if (this.advancedSearch == true) {
                this.smoothScrollUtil.focusOn('advanced-search');
            }
        }, 100);

    }

    private parseResults(autoCompletePromisesArray) {
        let results = [];
        let recentSearches = [];
        let tabsAndRecentSearchesList = [];
        let isSignedIn = this.jwtUtilService.isSignedIn();
        if(isSignedIn){
                let useSearchHistory = this.storageUtil.sessionStorage.getItem(this.USE_SEARCH_HISTORY)
                if (useSearchHistory != null) {
                    this.isUseSearchHistory = useSearchHistory === 'false' ? false : true;
                }
                if (this.isUseSearchHistory && this.isShowRecentSearches) {
                    recentSearches = this.getRecentSearches(this.mainSearchField);
                    if (recentSearches.length > 0) {
                        tabsAndRecentSearchesList = recentSearches.concat(tabsAndRecentSearchesList);
                    }
                }
        }
        else {//guest user
            if (this.isShowRecentSearches) {
                recentSearches = this.getRecentSearches(this.mainSearchField);
                if (recentSearches.length > 0) {
                    tabsAndRecentSearchesList = recentSearches.concat(tabsAndRecentSearchesList);
                }
            }
        }
        if (this.tabs.length > 1) {
            tabsAndRecentSearchesList = tabsAndRecentSearchesList.concat(this.tabs);
        }
        if (tabsAndRecentSearchesList.length > 0) {
            results.push(tabsAndRecentSearchesList);
        }
        let autocompleteResults = isEmpty(autoCompletePromisesArray) ? [] : get(autoCompletePromisesArray,'[0]',[]);
        if (autocompleteResults.length > 0) {
            let maxAutocompleteRows = recentSearches.length > 0 ? MAX_AUTOCOMPLETE_ROWS + NUMBER_OF_RECENT_SEARCHES : MAX_AUTOCOMPLETE_ROWS;
            let parsedResults = autocompleteResults
                .slice(0, maxAutocompleteRows - this.tabs.length)
                .map((e) => {
                    let aclength = this.autocompleteLength;
                    let short = this.stringUtil.abbreviate(e, aclength);
                    let json = {
                        display: e,
                        shortDisplay: short
                    };
                    return json;
                }
                );
            results.push(parsedResults);
        }

        let personsAutoCompleteItems = isEmpty(autoCompletePromisesArray) ? [] : get(autoCompletePromisesArray, '[1].data', []);
        if (!isEmpty(personsAutoCompleteItems)) {
            personsAutoCompleteItems = personsAutoCompleteItems.slice(0, MAX_PERSONS_AUTOCOMPLETE_ROWS)
                .map((personsAutoCompleteItem) => {return this.buildPersonsAutoCompleteItem(personsAutoCompleteItem);});
            results.push(personsAutoCompleteItems);
        }

        return results;

    }

    private autocompleteQuery(searchText) {
        this.typedQuery = searchText;
        if (!searchText || searchText.length < this.MIN_AUTOCOMPLETE_TERM_LENGTH) {
            return;
        }
        let body = document.getElementsByTagName('body')[0];
        if (this.autocompleteService.isAutocompleteEnabledFor(this.scopeField) || getEnablePersonEntityAutocomplete()) {
            if (this.hasSearchResults === 'false') {
                body.setAttribute('style', 'overflow-x: hidden'); //prevent screen "wobble"
            }

            let personAutocompleteApiUrl = this.PERSON_AUTOCOMPLETE_API_URL + "/suggest?q=" + searchText;
            let personsAutoCompletePromise = getEnablePersonEntityAutocomplete() ? this.$http.get(personAutocompleteApiUrl) : undefined;
            let autoCompletePromise = this.autocompleteService.isAutocompleteEnabledFor(this.scopeField) ? this.autocompleteService.search(searchText, this.scopeField) : undefined;
            this.autoCompleteItems = Promise.all([autoCompletePromise,personsAutoCompletePromise])
                .then(
                    (autoCompletePromisesArray) => {
                        let ret = this.parseResults(autoCompletePromisesArray);
                        return ret;
                    },
                    () => {
                        let ret = this.parseResults([]);
                        return ret;
                    }
                );
        } else {
            this.autoCompleteItems = this.parseResults([]);
        }
    }


    private buildPersonsAutoCompleteItem(personsAutoCompleteItem: any) {
        let personId = get(personsAutoCompleteItem, 'id');
        let linkToImage = get(personsAutoCompleteItem, 'image_info.link_to_image');
        let linkToImagePath = getUrlPathname(linkToImage).toLowerCase();
        linkToImage = (isEmpty(linkToImage) || !['gif', 'jpg', 'jpeg', 'png'].some(supportedImageFormat => linkToImagePath.endsWith(supportedImageFormat))) ? 'img/related_person_img.png' : linkToImage;
        let shortDescription = get(personsAutoCompleteItem, 'short_description.wikidata') ? ' | ' + get(personsAutoCompleteItem, 'short_description.wikidata') : '';
        let personName = get(personsAutoCompleteItem, 'person_name.LC');
        return {
            personId: personId,
            queryType: 'person',
            personName: personName,
            display: personName + shortDescription, // for search
            linkToImage: linkToImage,
            personsAutoCompleteItem: personsAutoCompleteItem
        };
    }


    public onSubmitPersonAutocomplete(person){
        let personEntityPagesParams = {
                personId: person.personId,
                vid: this.vid, 
                inst: getInstitutionCode(),
                lang: this.$translate.use()
            }
        this.mainSearchField = '';
        this.$state.go(STATE_NAMES.PERSON_ENTITY_PAGE, personEntityPagesParams, {reload: false});
        this.onSubmitPersonAutocompleteBeacon();
    }

    @beacon({ 'p': 'relatedPerson', 'op': 'relatedPersonFullPersonPageAutocomplete' })
    public onSubmitPersonAutocompleteBeacon() {
    }

    private onSelectItem() {
        if (!this.selectedItem) {
            return;
        }
        if ('person' === get(this.selectedItem, 'queryType', '')) {
            this.onSubmitPersonAutocomplete(this.selectedItem);
            return;
        }
        if (this.selectedItem.tab) {
            this.selectedTab = this.selectedItem.tab;
            this.scopeField = this.selectedItem.queryType === 'recentSearches' ? this.selectedItem.scope : this.searchScopesMap[this.selectedTab][0]['scope-id'];
        }
        this.acTriggered = !this.selectedItem.tab && this.selectedItem.queryType != 'recentSearches' ? true : false;
        this.onSubmit();
        if (getBackendSystem() !== 'suprima') {
            this.updateShowFindDBButton();
        }
    }

    private onSubmit() {
        if (this.configurationUtil.getUseEsploroSearchPage()) {
            const esploroSearchUrl = this.templateUtil.getBaseUrl() + '/esploro/search/outputs?query=any,contains,' + this.mainSearchField + '&page=1&institution=' + getInstitutionCode();
            window.open(esploroSearchUrl, "_blank");
            return;
        }
        this.showTabsAndScopes = true;
        if (this.mainSearchField) {
            window.appPerformance.timeStamps['search button clicked'] = Date.now();
            this.typedQuery = this.mainSearchField;
            this.autoCompleteItems = [];
            if (!this._scopeField && !this.selectedTab) {
                this.selectedTab = this.tabs[0].tab;
                this.scopeField = this.searchScopesMap[this.selectedTab][0]['scope-id'];
            }
            this.searchFieldsService.tab = this.selectedTab;
            this.searchFieldsService.scope = this.scopeField;
            if (this.$location.search().tab !== this.selectedTab) {
                //                this.addTabToUrl();
            }

            let eventData = this.createSearchEvent();

            this.searchEvent.emit(eventData);
            this.searchHistoryItems.unshift({ query: eventData.mainSearchField, scope: this.scopeField, tab: this.selectedTab });
        }

        // Only for mobile -  This for auto-closing of the keyboard when the user clicks search from the mobile keyboard button
        if (!this.mediaQueries.gtmd) {
            document.getElementById("searchBar").blur();
        }

        // This is to solve quick search issue when click Enter before autocomplete dropdwon opening - PRM-45747
        this.$timeout(() => {
            let clearClass = document.getElementsByClassName('md-scroll-mask');
            if (clearClass != null && clearClass[0] != null) {
                clearClass[0].classList.remove('md-scroll-mask');
            }
        }, 1000);

        if(this.isKeepMeSignInEnabled()) {
            if (this.timeoutToastService.showTimeOutToastMessage === true) {
                this.timeoutToastService.showTimeOutToastMessage = false;
            }
        }

    }

    private onVoiceSearchStart() {
        if (annyang) {
            let _this = this;
            let commands = {
                '*searchString': function (searchString) {
                    _this.executeVoiceSearch(searchString, _this);
                }
            };

            annyang.removeCommands();
            annyang.addCommands(commands); // Add the commands to annyang
            annyang.start();// Start listening.
            this.openVoiceSearchToast();
        }
    }

    private executeVoiceSearch(searchString, _this) {
        _this.searchService.cameFromState = 'voiceSearch';
        _this.mainSearchField = searchString;
        _this.executeVoiceSearchBeacon();
        _this.onSubmit();
        _this.voiceSearchToastService.executeVoiceSearch(searchString);
    }

    private openVoiceSearchToast() {
        let templateString = '<prm-voice-search-toast></prm-voice-search-toast>';

        this.$mdToast.show({
            hideDelay: 60000,
            position: 'top right',
            template: templateString
        }).then(() => {
            this.addQueryToSavedSearchesService.onToastClose()
        });
    }

    @beacon({ 'p': 'voiceSearch', 'op': 'voiceSearch' })
    public executeVoiceSearchBeacon() {
    }

    private createSearchEvent() {
        let eventData = {
            mainSearchField: this.getMainSearchField(),
            scopeField: this.scopeField,
            tab: this.selectedTab,
            mode: null,
            facet: [],
            mfacet: [],
            citationTrailFilterByAvailability: this.$location.search().citationTrailFilterByAvailability
        };

        //Fix for URM-189450 ( collection is indexed without s)
        if (this.pFilters.mediaType) {
            if (this.pFilters.mediaType=== "collections"){
                this.pFilters.mediaType = "collection";
            }
            eventData.pfilter = ['pfilter,exact,' + this.pFilters.mediaType];

            if (getBackendSystem() === 'suprima') {
                eventData.pfilter = ['rtype,exact,' + this.pFilters.mediaType];
            }
        }

        this.searchService.cameFromState = (this.isPreFilterSubmitted()) ? 'preFilter' : this.searchService.cameFromState;

        return eventData;
    }

    private getMainSearchField() {
        let queryArray = [];
        queryArray.push(this.pFilters.targetField || this.DEFAULT_TARGET_OPERATOR);
        queryArray.push(this.pFilters.operator || this.DEFAULT_SEARCH_OPERATOR);
        queryArray.push(this.mainSearchField);
        return queryArray.join(",");
    }

    @preventStateReload
    private addTabToUrl() {
        this.$location.search('tab', this.searchFieldsService.tab);
    }

    public updateShowFindDBButton(tab?) {
        let chosenTab = tab ? tab : this.selectedTab;
        this.tabsAndScopesSelectorService.updateIsRemoteTab(chosenTab);
		if (!getFindInDbPerTabs()) {
			this.isShowFindDBButton = false;
			return;
		}
        let configurdByTab = getFindInDbPerTabs()[chosenTab] ? getFindInDbPerTabs()[chosenTab] : false;
        this.isShowFindDBButton = this.tabsAndScopesSelectorService.isRemoteTab || configurdByTab;
    }

    public isPreFilterSubmitted() {
        return this.pFilters.mediaType ||
            (this.pFilters.targetField && (this.pFilters.targetField !== this.DEFAULT_TARGET_OPERATOR)) ||
            (this.pFilters.operator && (this.pFilters.operator !== this.DEFAULT_SEARCH_OPERATOR));
    }


    private onFindDBDialogClose(data: { selectedSetId: string }) {
        this.tabsAndScopesSelectorService.updateScopes().then((res) => {
            updateSearchScopesMap(res.data);
            if (data && data.selectedSetId) {
                let selectedSetId = data.selectedSetId === 'Current Session' ? 'Selected_Databases' : data.selectedSetId;
                let tabName = this.tabsAndScopesSelectorService.findTabByScopeName(selectedSetId);
                if (!tabName) {
                    console.log('error could not find "find DB" selected scope in any tab');
                    return;
                }
                let params = this.$state.params;
                params['tab'] = tabName;
                params['search_scope'] = selectedSetId;
                this.$state.transitionTo(this.$state.current, params, { reload: true });
            } else {
                this.$state.reload(); //reload state to refresh the scopes and tabs list
            }
        });
    }

    public openFdbIframe() {
        let vm = this;
		let searchModeParam = '&searchMode=' + (this.advancedSearch ? 'advance' : 'simple');

		let findDBDialogPromise: ng.IPromise<Object> = this.$mdDialog.show({
            bindToController: true,
            controller: function () {
                this.displayFDBNothingSelectedErr = false;
                let handle = vm.jwtUtilService.getPdsHandle();//pds_handle
                let userId = !handle ? vm.jwtUtilService.getDecodedToken()['user'] : '';
                this.getUrl = function () {
                    return vm.$location.protocol() + '://' + vm.$location.host() + ':' + vm.$location.port() + '/primo_library/libweb/searchDB?fn=nuiSearchDbIframe&vid=' + vm.vid + '&pds_handle=' + handle + '&guestID=' + userId + searchModeParam;
                };
                this.closeDialog = function () {
                    vm.$mdDialog.hide();
                };

                this.goToSearch = function () {
                    let retrievedObject = vm.storageUtil.localStorage.getItem('selectedSetId'); //retrieve scope id from local storage
                    if (retrievedObject) {
                        vm.storageUtil.localStorage.removeItem('selectedSetId'); //once we have retrieved the selected id we delete it to prevent confusion in the future
                        let selectedSetId = JSON.parse(retrievedObject);
                        vm.$mdDialog.hide(selectedSetId); //set the data for the findDBDialogPromise callback
                    } else {
                        this.displayFDBNothingSelectedErr = true; // if retrieved object is null it means that nothing was selected in find db iframe and we display error message
                    }
                }
            },
            controllerAs: 'ctrl',
            templateUrl: 'components/search/topbar/mainMenu/find-db-dialog-template.html'
        });

        findDBDialogPromise.then((data: { selectedSetId: string }) => {
            this.onFindDBDialogClose(data)
        });


 	}


    public setSearchHistoryItems() {

        if (this.searchHistoryService.isLoggedIn()) {
            this.savedQueriesService.makeRequest('get', null, 'GET', '?vid=' + getVid() + '&type=10')  // type=10 is for getting only search history Items, that are stored in the DB for a logged in user 
                .then((data) => {// gets the search history items array from the DB for a logged in user.
                    this.searchHistoryItems = data ? data.searchesList : [];
                });
        }
        else {
            let localForageKey = this.jwtUtilService.getDecodedToken().user + "_SearchHistoryQeuriesKey";
            this.storageUtil.$localForage.getItem(localForageKey)
                .then((data) => { // gets the search history items array from the local forage for a guest.
                    this.searchHistoryItems = data ? data : [];
                });
        }
    }

    public getRecentSearches(searchText) {
        let recentSearches = [];
        let configuredTabsList = Object.keys(this.searchScopesMap);
        let configuredScopesList = getScopeList().map((scope) => { return scope['scope-id'] });
        for (let i = 0; i < this.searchHistoryItems.length && recentSearches.length < NUMBER_OF_RECENT_SEARCHES; i++) {
            let arr = this.searchHistoryItems[i].query.split(',');
            let queryString = arr[2] ? decodeURIComponent(arr[2]) : arr[2];
            if (arr.length > 2 && queryString.toLowerCase().startsWith(searchText.toLowerCase()) && this.searchHistoryItems[i].mode != 'advanced' && configuredTabsList.indexOf(this.searchHistoryItems[i].tab) > -1 && configuredScopesList.indexOf(this.searchHistoryItems[i].scope) > -1) {
                recentSearches.push({
                    display: queryString,
                    shortDisplay: queryString,
                    tab: decodeURIComponent(this.searchHistoryItems[i].tab),
                    scope: decodeURIComponent(this.searchHistoryItems[i].scope),
                    queryType: 'recentSearches'
                });
                break;
            }
        }
        return recentSearches;
    }

    public isBarcodeSearchTab(){
        return this.$location.search().searchType === 'barcode' ? true : false;
    }

    get facetToLeft() {
        let viewConfig = getAttributesMap();
        return viewConfig['selectedFacetLocation'] === 'left';
    }

    get isShowFindDBButton(): boolean {
        return this._isShowFindDBButton;
    }

    set isShowFindDBButton(value: boolean) {
        this._isShowFindDBButton = value;
    }

    get isShowRecentSearches(): boolean {
        return this._isShowRecentSearches;
    }

    set isShowRecentSearches(value: boolean) {
        this._isShowRecentSearches = value;
    }

    get showVoiceSearchButton(): boolean {
        let viewConfig = getAttributesMap();
        return annyang && viewConfig['displayVoiceSearch'];
    }

    get isLandscapeView(): boolean {
        return window.matchMedia("(orientation: landscape)").matches;
    }

    public isKeepMeSignInEnabled() {
        let chosenConf = getChosenKeepMeSignInConf();
        
        if(this.configurationUtil.getBackendSystem() === 'suprima'){
            let keepMeSignInFeatureFlag = this.configurationUtil.getFeatureFlag('enable_patrons_to_check_keep_me_signed_in');
            return chosenConf != null && keepMeSignInFeatureFlag;
        }
        
        return chosenConf != null;
    }

    get isResearchAssistantByIcon(): boolean {
        return isShowReasearcherAssistantByIcon();
    }

    get researchAssistantParams() {
        return {vid: this.vid, lang: this.$translate.use()};
    }
}

interface ScopesDialerConfiguration {
    display: boolean;
    isOpen: boolean;
    direction: string;
    iconsArray: Object[];
    autoHideToolTip: boolean;
    toolTipDelay: number;
    toolTipDirection: string;
    tooTipDefaultOpen: boolean;
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/searchBar.directive.ts